module.exports = __webpack_public_path__ + "static/media/analysis-icon.312c1970.svg";